(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-sub-category', {
            parent: 'entity',
            url: '/customer-sub-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerSubCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-categories.html',
                    controller: 'CustomerSubCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerSubCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-sub-category-detail', {
            parent: 'entity',
            url: '/customer-sub-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerSubCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-category-detail.html',
                    controller: 'CustomerSubCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerSubCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerSubCategory', function($stateParams, CustomerSubCategory) {
                    return CustomerSubCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer-sub-category.new', {
            parent: 'customer-sub-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-category-dialog.html',
                    controller: 'CustomerSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-sub-category', null, { reload: true });
                }, function() {
                    $state.go('customer-sub-category');
                });
            }]
        })
        .state('customer-sub-category.edit', {
            parent: 'customer-sub-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-category-dialog.html',
                    controller: 'CustomerSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerSubCategory', function(CustomerSubCategory) {
                            return CustomerSubCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-sub-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-sub-category.delete', {
            parent: 'customer-sub-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-sub-category/customer-sub-category-delete-dialog.html',
                    controller: 'CustomerSubCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerSubCategory', function(CustomerSubCategory) {
                            return CustomerSubCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-sub-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
